'use strict';

/**
 * @ngdoc directive
 * @name 360StoreAngularApp.directive:stRenewableItem
 * @description
 * # stRenewableItem
 */
angular.module('360StoreAngularApp')
	.directive('stRenewableItem', function (BUILD_DATE) {
		return {
			restrict: 'E',
			// The `scope` property is the .directive() equivalent of .component() `bindings`
			scope: {
				item: '<',
				credentials: '<',
				onToggle: '&'
			},
			// Use an injectable function to get the BUILD_DATE constant
			templateUrl: 'views/st-renewable-item.html?v=' + BUILD_DATE,
			/**
			 * @param $scope {$scope & {item: MaintenanceOption, credentials: '<Object>', onToggle:function({item: MaintenanceOption}): void}}
			 * @param moment
			 */
			controller: function ($scope, moment) {
				let nextDailySchedule = moment().utc().set({hour: 19, minute: 24, second: 0});
				if ( nextDailySchedule.toDate().getTime() < Date.now() ) {
					nextDailySchedule = nextDailySchedule.add(1, 'day');
				}

				$scope.handleToggle = function () {
					if ($scope.item.disabled) {
						return;
					}
					$scope.onToggle({item: $scope.item});
				};

				$scope.autoRenewDate = function () {
					let when = moment($scope.item.maxReleaseDate).add(-5, 'day').add(19, 'hour'); // @see DailyTimerTask#DAYS_PRIOR_TO_AUTORENEW_TO_RENEW_ON
					// the `when` is in localTime not GMT, but it doesn't matter that much, if we're close to nextDailySchedule that will show up instead
					if (when < nextDailySchedule) {
						when = nextDailySchedule;
					}
					return when.fromNow() + ' (' + when.format('M/D/YY') + ')';
				};

				$scope.maintenanceOrSubscription = () => {
					return $scope.item.licenseType === 'AnnualSubscription' ? 'Subscription' : 'Maintenance';
				};

				/**
				 * @return {string|null} "monthly" / "quarterly", or null for the annual default, which needs no comment
				 */
				$scope.billingPeriodAdverb = () => {
					switch ($scope.item.billingPeriod) {
						case 'Monthly':
							return 'monthly';
						case 'Quarterly':
							return 'quarterly';
						default:
							return null;
					}
				};

				$scope.maintenanceEnd = function () {
					const when = moment($scope.item.maxReleaseDate);
					return when.fromNow() + ' (' + when.format('M/D/YY') + ')';
				};

			}
		};
	});
